const assetUrls=JSON.parse(document.getElementById("mom-index-assets").textContent);
const frames={
  monogram:{file:'logo-black.png',size:[2480,3508],crop:[378,1579,825,578]},
  wordmark:{file:'logo-white.png',size:[2480,3508],crop:[278,86,1878,1043]},
  hand:{file:'hand.png',size:[617,988],crop:[27,47,590,841]},
  home:{file:'text-home.png',size:[669,431],crop:[38,91,627,258]},
  info:{file:'text-info.png',size:[452,275],crop:[13,9,416,246]},
  shop:{file:'text-shop.png',size:[436,324],crop:[15,10,416,307]},
  archive:{file:'text-archive.png',size:[759,262],crop:[12,8,743,246]},
  contact:{file:'text-contact.png',size:[840,280],crop:[4,21,830,227]},
  cart:{file:'text-cart.png',size:[525,219],crop:[17,18,485,178]},
  '(':{file:'text-(.png',size:[161,231],crop:[24,12,91,205]},
  ')':{file:'text-).png',size:[122,220],crop:[28,20,74,178]},
  '0':{file:'text-0.png',size:[108,111],crop:[10,13,87,96]}
};
function frameAssets(root=document){
 root.querySelectorAll('[data-frame]').forEach(el=>{
  if(el.firstChild)return;
  const {file,size:[sw],crop:[x,y,w,h]}=frames[el.dataset.frame];
  el.style.setProperty('--frame-ratio',`${w}/${h}`);
  const img=document.createElement('img');img.src=assetUrls[file];img.alt='';img.draggable=false;
  Object.assign(img.style,{width:`${sw/w*100}%`,left:`${-x/w*100}%`,top:`${-y/h*100}%`});el.append(img);
 });
}

Object.assign(frames,{"1": {"file": "text-1.png", "size": [64, 107], "crop": [18, 7, 27, 96]}, "2": {"file": "text-2.png", "size": [90, 110], "crop": [6, 7, 75, 96]}, "3": {"file": "text-3.png", "size": [64, 118], "crop": [6, 12, 53, 97]}, "4": {"file": "text-4.png", "size": [87, 116], "crop": [8, 9, 79, 107]}, "5": {"file": "text-5.png", "size": [91, 98], "crop": [5, 7, 83, 88]}, "6": {"file": "text-6.png", "size": [82, 133], "crop": [6, 15, 73, 97]}, "7": {"file": "text-7.png", "size": [99, 111], "crop": [10, 11, 86, 99]}, "8": {"file": "text-8.png", "size": [79, 128], "crop": [8, 11, 65, 109]}, "9": {"file": "text-9.png", "size": [64, 123], "crop": [5, 10, 59, 105]}});
frameAssets();
